import { GeneratedContent } from "@/types/content";
import { Play, Pause, SkipBack, SkipForward, Volume2 } from "lucide-react";
import { useState } from "react";

interface PodcastPreviewProps {
  content: GeneratedContent;
}

export const PodcastPreview = ({ content }: PodcastPreviewProps) => {
  const [isPlaying, setIsPlaying] = useState(false);
  
  return (
    <div className="max-w-3xl mx-auto">
      {/* Podcast player */}
      <div className="bg-gradient-to-r from-blue-500/10 to-blue-500/10 rounded-lg p-6 border border-blue-500/20">
        <div className="flex items-center gap-4">
          {/* Podcast cover art */}
          <div className="w-24 h-24 bg-gradient-to-br from-blue-500 to-blue-500 rounded-lg flex items-center justify-center shadow-lg">
            <svg 
              className="w-12 h-12 text-white" 
              fill="none" 
              stroke="currentColor" 
              viewBox="0 0 24 24" 
              xmlns="http://www.w3.org/2000/svg"
            >
              <path 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                strokeWidth={2} 
                d="M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z" 
              />
            </svg>
          </div>
          
          {/* Podcast info */}
          <div className="flex-1">
            <h3 className="text-lg font-semibold">{content.title}</h3>
            <p className="text-sm text-muted-foreground">
              Episode {Math.floor(Math.random() * 100) + 1} • {content.metadata?.duration || "45:30"}
            </p>
            
            {/* Player controls */}
            <div className="mt-4 flex items-center gap-4">
              <button className="text-muted-foreground hover:text-foreground">
                <SkipBack className="h-5 w-5" />
              </button>
              
              <button 
                className="w-10 h-10 bg-gradient-to-r from-blue-500 to-blue-500 rounded-full flex items-center justify-center text-white shadow-md hover:opacity-90 transition-opacity"
                onClick={() => setIsPlaying(!isPlaying)}
              >
                {isPlaying ? (
                  <Pause className="h-5 w-5" />
                ) : (
                  <Play className="h-5 w-5 ml-0.5" />
                )}
              </button>
              
              <button className="text-muted-foreground hover:text-foreground">
                <SkipForward className="h-5 w-5" />
              </button>
              
              <div className="flex-1 h-1 bg-muted rounded-full overflow-hidden">
                <div className="h-full w-0 bg-blue-500 rounded-full"></div>
              </div>
              
              <button className="text-muted-foreground hover:text-foreground">
                <Volume2 className="h-5 w-5" />
              </button>
            </div>
          </div>
        </div>
      </div>
      
      {/* Podcast script */}
      <div className="mt-8 space-y-6">
        <div className="space-y-4">
          <h2 className="text-lg font-semibold border-b pb-2">Podcast Script</h2>
          <div className="prose max-w-none dark:prose-invert">
            <div className="whitespace-pre-wrap">{content.content}</div>
          </div>
        </div>
      </div>
    </div>
  );
}; 